export default {"src":"/_next/static/media/small-area.f835120e.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};